<!-- Tool activity pills -->
@if (msg.toolActivity && msg.toolActivity.length > 0) {
  <div class="air-tool-pills">
    @for (tool of msg.toolActivity; track $index) {
      <span class="air-tool-pill"
        [class.air-tool-pill--running]="tool.status === 'running'"
        [class.air-tool-pill--done]="tool.status === 'done'"
        [class.air-tool-pill--error]="tool.status === 'error'">
        <i class="pi"
          [class.pi-spin]="tool.status === 'running'"
          [class.pi-cog]="tool.status === 'running'"
          [class.pi-check]="tool.status === 'done'"
          [class.pi-times]="tool.status === 'error'"
          aria-hidden="true">
        </i>
        <span>{{ toolLabel(tool.name) }}</span>
        @if (tool.error) {
          <span class="air-tool-pill__error">{{ tool.error }}</span>
        }
      </span>
    }
  </div>
}

<!-- Markdown content with footer stripped -->
@if (msg.content) {
  <div class="air-content" [innerHTML]="stripFooter(msg.content) | markdown"></div>
}

<!-- Quick-action bar — shown when agent appended the "What would you like to do next?" footer -->
@if (hasFooter(msg.content) && !msg.isThinking) {
  <div class="air-next-actions">
    <span class="air-next-actions__label">What would you like to do next?</span>
    <div class="air-next-actions__buttons">
      @for (action of nextActions; track action.value) {
        <button
          class="air-next-action-btn"
          type="button"
          [disabled]="isProcessing || isPast"
          (click)="onQuickAction(action.value)"
          [attr.aria-label]="action.label">
          <i class="pi {{ action.icon }}" aria-hidden="true"></i>
          <span>{{ action.label }}</span>
        </button>
      }
    </div>
  </div>
}

<!-- Download buttons -->
@if (hasDownloads) {
  <div class="air-downloads">
    @for (item of msg.downloads; track item.filename) {
      <button class="air-download-btn" (click)="onDownload(item)" title="Download {{ docLabel(item) }}">
        <i class="pi pi-download" aria-hidden="true"></i>
        <span>{{ docLabel(item) }}</span>
      </button>
    }
  </div>
}
